module.exports = __webpack_public_path__ + "static/media/Caretaking_parenting.d0e6e597.png";